import React, { useRef } from "react";
import Box from "@mui/material/Box";
import { useStyles } from "./heroStyles";
import useHeroAnimations from "../../hooks/animations/useHeroAnimations";

export interface IHero {
    header: string;
    backgroundImage?: string;
    backgroundColor?: string;
}
const Hero = ({ header, backgroundImage, backgroundColor }: IHero) => {
    const { classes } = useStyles({ backgroundImage, backgroundColor });
    const root = useRef(null);
    useHeroAnimations(root);
    return (
        <div id="hero" className={classes.outer}>
            <Box data-name="Hero" ref={root} className={`${classes.root} root`}>
                <Box className={classes.gradient}>
                    <Box id="header" className={classes.headerContainer}>
                        <p>{header}</p>
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default Hero;
